import { useLocation } from 'react-router-dom'
import type { THref } from './types'

export function useHref() {
  const location = useLocation()

  return (href: THref) => {
    // Handle React Router 5 location objects
    if (typeof href === 'object') {
      const { pathname, search, hash } = href
      let url = pathname || location.pathname

      if (search) {
        url += search.startsWith('?') ? search : `?${search}`
      }

      if (hash) {
        url += hash.startsWith('#') ? hash : `#${hash}`
      }

      return url
    }

    if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return href
    }

    if (href.startsWith('/')) {
      return href
    }

    // Relative path - resolve against current location
    const basePath = location.pathname.endsWith('/') ? location.pathname : `${location.pathname}/`

    return basePath + href
  }
}
